import { authAPI } from '../../api'

const user = JSON.parse(localStorage.getItem('user'))
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null }

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        LOGIN: ({ commit }, { username, password }) => new Promise((resolve, reject) => {
            authAPI.LOGIN({ username: username, password: password }).then(
                ({ data }) => {
                    commit('AUTH', data)
                    resolve()
                },
                error => reject(error)
            )
        }),
        LOGOUT: ({ commit }) => new Promise(resolve => authAPI.LOGOUT().then(() => {
            commit('LOGOUT')
            resolve()
        })),
        REFRESH: ({ commit }) => authAPI.REFRESH().then(({ data }) => commit('AUTH', data))
    },
    mutations: {
        AUTH: (state, user) => {
            state.status.loggenIn = true
            state.user = user
            localStorage.setItem('user', JSON.stringify(user))
            window.axios.defaults.headers.common['Authorization'] =
                'Bearer ' + user.access_token
        },
        LOGOUT: state => {
            state.status = {}
            state.user = null
            localStorage.removeItem('user')
        },
    },
}
